//import type {BffResponse} from '@esofertasv2/bff';
import { Spinner, styled } from '@volkswagen-onehub/components-core';
import React, { useContext, useEffect, useState } from 'react';
import { Ofertas } from './components/ofertas';
import { OfertasContext } from './context/ofertas-context';
import { getDisclaimers, RegisteredDisclaimer } from './helpers/get-disclaimer';
import {
	getFinanciacionType,
	getPagoFinanciado,
	getPagoUnico,
} from './helpers/ofertas-helper';
import { useDisclaimerReference } from './helpers/useDisclaimerReference';
import {
	CarlineWithOfertas,
	filtersFaContentOfertas,
} from './services/ofertas-service/models/ofertas';
import { useTrackingManager } from './tracking/use-tracking-manager';
import { setGlobalDisclaimer } from './utils/set-global-disclaimer';

const Content = styled.div`
	background-color: white;
	padding: 44px 31px;
	flex: auto;
	text-align: center;
	width: 100%;
	margin-top: 10%;

	@media screen and (min-width: 560px) {
		padding: 52px 46px;
	}

	@media screen and (min-width: 960px) {
		padding: var(--size-grid001);
	}
`;

export function Home(): JSX.Element {
	const {
		disclaimerManager,
		pageInfoService,
		breacrumbService,
		ofertasService,
		contentService,
	} = useContext(OfertasContext);

	const [carlines, setCarlines] = useState<CarlineWithOfertas[]>([]);
	const [selectedGamaFilter, setSelectedGamaFilter] = useState<string | null>(
		null,
	);
	const [selectedMotorizacionFilter, setSelectedMotorizacionFilter] = useState<
		string | null
	>(null);
	const [isFilterSelected, setisFilterSelected] = useState<boolean>(false);
	const [emptyCarlines, setEmptyCarlines] = useState<boolean>(false);
	const [disclaimers, setDisclaimers] = useState<RegisteredDisclaimer[]>([]);
	const [hasOneCarline, setHasOneCarline] = useState<boolean>(false);
	const [isCallMeNowOpen, setIsCallMeNowOpen] = useState<boolean>(false);

	const filtersFaContentOfertas =
		contentService?.content as filtersFaContentOfertas;

	const trackingManager = useTrackingManager();

	const scopedDisclaimerManager =
		disclaimerManager.getScopedDisclaimerManager();

	useDisclaimerReference(disclaimers);
	setGlobalDisclaimer(scopedDisclaimerManager);

	const handleFilteredCarlines = (selectedButton: string) => {
		if (
			selectedGamaFilter === selectedButton ||
			selectedMotorizacionFilter === selectedButton
		) {
			return;
		}

		setisFilterSelected(true);
		setCarlines([]);
	};

	//Detect author mode
	const params = new URLSearchParams(window.location.search);
	const authorMode = params.get('appId') == 'aemshell' ? true : false;

	useEffect(() => {
		breacrumbService.set([]);
		pageInfoService.setPageInfo();
	}, [pageInfoService, breacrumbService]);

	useEffect(() => {
		ofertasService
			.getOfertas(filtersFaContentOfertas)
			.then((carlines) => {
				setCarlines(carlines);
				const currentDisclaimers = getDisclaimers(carlines);

				if (carlines.length === 1) {
					setHasOneCarline(true);
				}

				if (carlines.length === 0) {
					setEmptyCarlines(true);
				}

				setDisclaimers(currentDisclaimers);
			})
			.catch((error) => {
				console.error('Error al obtener las ofertas:', error);
			});

		ofertasService
			.getIsCallMeNowOpen()
			.then((isOpen) => {
				console.log("getCallMeNowOpen",isOpen);
				setIsCallMeNowOpen(isOpen);
			})
			.catch((error) => {
				console.error('Error al cargar status de Call Me Now:', error);
			})

	}, [filtersFaContentOfertas, ofertasService]);

	useEffect(() => {
		const filteredCarlines = ofertasService.filterOfertas(
			selectedGamaFilter,
			selectedMotorizacionFilter,
		);

		setCarlines(filteredCarlines);

		if (!isFilterSelected && carlines.length > 0) {
			const pagoFinanciado = getPagoFinanciado(
				carlines[0].ofertas[0]?.datosEconomicos,
			);
			trackingManager.trackOfertasGenericFeatureAppLoad({
				CarlineId: carlines[0].code.toString(),
				CarlineName: carlines[0].title,
				SalesgroupName: carlines[0].ofertas[0]?.carline?.salesgroup.title,
				ModelId:
					carlines[0].ofertas[0]?.configuracion.motorizacion.code?.split(
						'-',
					)[0],
				ModelName: carlines[0].ofertas[0]?.carline?.salesgroup.model.name,
				ModelYear: carlines[0].ofertas[0]?.carline?.salesgroup.year.toString(),
				PriceRateType: pagoFinanciado
					? getFinanciacionType(pagoFinanciado)
					: undefined,
				PriceRateTotal: pagoFinanciado?.precio ?? undefined,
				PriceRateCurrency: 'EUR',
				PriceTotalTotal:
					getPagoUnico(carlines[0].ofertas[0]?.datosEconomicos)?.precio ??
					undefined,
				PriceTotalCurrency: 'EUR',
			});
		}

		if (isFilterSelected && carlines.length > 0) {
			const pagoFinanciado = getPagoFinanciado(
				carlines[0].ofertas[0]?.datosEconomicos,
			);
			trackingManager.trackOfertasVehiclePageload({
				CarlineId: carlines[0].code.toString(),
				CarlineName: carlines[0].title,
				SalesgroupName: carlines[0].ofertas[0]?.carline?.salesgroup.title,
				ModelId:
					carlines[0].ofertas[0]?.configuracion.motorizacion.code?.split(
						'-',
					)[0],
				ModelName: carlines[0].ofertas[0]?.carline?.salesgroup.model.name,
				ModelYear: carlines[0].ofertas[0]?.carline?.salesgroup.year.toString(),
				PriceRateType: pagoFinanciado
					? getFinanciacionType(pagoFinanciado)
					: undefined,
				PriceRateTotal: pagoFinanciado?.precio ?? undefined,
				PriceRateCurrency: 'EUR',
				PriceTotalTotal:
					getPagoUnico(carlines[0].ofertas[0]?.datosEconomicos)?.precio ??
					undefined,
				PriceTotalCurrency: 'EUR',
			});

			setisFilterSelected(false);
		}
	}, [
		selectedGamaFilter,
		selectedMotorizacionFilter,
		ofertasService,
		isFilterSelected,
		trackingManager,
	]);

	return (
		<>
			{!authorMode && carlines.length > 0 ? (
				<Ofertas
					carlines={carlines}
					hasOneCarline={hasOneCarline}
					handleFilteredCarlines={handleFilteredCarlines}
					selectedGamaFilter={selectedGamaFilter}
					selectedMotorizacionFilter={selectedMotorizacionFilter}
					setSelectedGamaFilter={setSelectedGamaFilter}
					setSelectedMotorizacionFilter={setSelectedMotorizacionFilter}
					isCallMeNowOpen={isCallMeNowOpen}
				/>
			) : emptyCarlines ? (
				<></>
			) : (
				<Content>
					<Spinner variant="x-large" />
				</Content>
			)}
		</>
	);
}
